import firebase from "@firebase/app";
import "@firebase/firestore";
import "@firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyBYDrWjb2hg8RE9YGplEcebWnS5rxbneD8",
    authDomain: "ihatoo.firebaseapp.com",
    projectId: "ihatoo",
    storageBucket: "ihatoo.appspot.com",
    messagingSenderId: "839039624688",
    appId: "1:839039624688:web:a0ff0019984ad96e6c6935",
    measurementId: "G-06HVMT30DX"
}


const app = firebase.initializeApp(firebaseConfig, {
    name: 'hatu'
})
let { logEvent } = firebase.analytics(app)

export {
    logEvent
}




// WEBPACK FOOTER //
// ./src/firebaseHatu/index.js